import { updateListingScore } from '../../product/score';
import { replaceOperation } from '../../product/operations';
import { editDescription } from '../description';

import { ATTRIBUTE } from '../../../constants/attributes';
import { EMPTY } from '../../../constants';

export function description({ operation, product, titleFormatPreference, ...rest }) {
  const value = operation.get('value');
  const updates = editDescription({ product, value });

  if (updates.product.hasIn(['score', ATTRIBUTE.DESCRIPTION])) {
    updates.product = updateListingScore(updates.product, { titleFormatPreference });
  }

  return {
    ...rest,
    product: updates.product = updates.product.set('operations',
      updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
    ),
  };
}
